// @ts-nocheck
import React from 'react';
import { Button } from 'reactstrap';
import { Avatar, Row, Col, Button as AntdButton, Card } from 'antd';
import { RightOutlined, LeftOutlined } from 'antd/icons';
import useIsClinician from '../../hooks/useIsClinician';
import { useTranslation } from 'react-i18next';

const Pagination = ({ pageNumber, setPageNumber, isLastPage, loading, setLoading }) => {
  const { t } = useTranslation('common');
  const isClinician = useIsClinician();

  const isAdminNextBtnDisabled = isLastPage || loading;
  const isPreviousBtnDisabled = pageNumber <= 1;

  return (
    <div style={{ margin: 20 }}>
      <Row justify="space-between">
        <Col span={8}>
          {isClinician ? (
            <AntdButton
              type="primary"
              style={{ padding: '5px 20px' }}
              disabled={isPreviousBtnDisabled}
              onClick={() => setPageNumber((val) => val - 1)}
              className="pagination-button"
              data-testid="previous-page"
            >
              <LeftOutlined />
              {t('Previous')}
            </AntdButton>
          ) : (
            <Button
              type="primary"
              style={{ padding: '5px 20px' }}
              disabled={isPreviousBtnDisabled}
              onClick={() => setPageNumber((val) => val - 1)}
              className="vl-button vl-button--min button"
              data-testid="previous-page"
            >
              <LeftOutlined style={{ fontSize: '160%' }} />
              {t('Previous')}
            </Button>
          )}
        </Col>
        <Col>
          {isClinician ? (
            <Card styles={{ body: { padding: '0.5em 1em' } }} className="pagination-page-number" data-testid={'page-counter'}>
              {pageNumber}
            </Card>
          ) : (
            <Avatar
              shape="square"
              style={{ color: '#000000' }}
              size={{ xs: 24, sm: 32, md: 40, lg: 40, xl: 40, xxl: 40 }}
              data-testid={'page-counter'}
            >
              {pageNumber}
            </Avatar>
          )}
        </Col>
        <Col span={8}>
          {isClinician ? (
            <AntdButton
              type="primary"
              disabled={isLastPage}
              onClick={() => {
                setPageNumber((val) => val + 1);
              }}
              style={{ float: 'right' }}
              className="pagination-button"
              data-testid="next-page"
            >
              {t('Next')}
              <RightOutlined />
            </AntdButton>
          ) : (
            <Button
              type="primary"
              className="vl-button vl-button--min button"
              style={{ color: isAdminNextBtnDisabled ? '#FFFFFF' : 'var(--productPrimaryDark)', float: 'right' }}
              disabled={isAdminNextBtnDisabled}
              data-testid="next-page"
              onClick={() => {
                setLoading(true);
                setPageNumber((val) => val + 1);
              }}
            >
              {t('Next')}
              <RightOutlined style={{ fontSize: '160%' }} />
            </Button>
          )}
        </Col>
      </Row>
      <Row justify="space-between">
        <Col span={8}>
          {isClinician ? (
            <AntdButton
              type="primary"
              disabled={pageNumber <= 1}
              onClick={() => setPageNumber(1)}
              className="pagination-button"
              data-testid="first-page"
            >
              <LeftOutlined />
              {t('First page')}
            </AntdButton>
          ) : (
            <Button
              type="primary"
              className="vl-button vl-button--min button"
              style={{
                color: isPreviousBtnDisabled || loading ? '#FFFFFF' : 'var(--productPrimaryDark)',
                padding: '5px 15px'
              }}
              data-testid="first-page"
              disabled={pageNumber <= 1 || loading}
              onClick={() => {
                setLoading(true);
                setPageNumber(1);
              }}
            >
              <LeftOutlined style={{ fontSize: '160%' }} />
              {t('First page')}
            </Button>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Pagination;
